import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  PLATFORM_ID} from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { provideRouter, withInMemoryScrolling } from "@angular/router";
import { routes } from "./app.routes";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi} from "@angular/common/http";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { AuthInterceptor } from "./core/interceptors/auth.interceptor";
import { ErrorInterceptor } from "./core/interceptors/error.interceptor";
import { provideStore, Store } from "@ngxs/store";
import { withNgxsReduxDevtoolsPlugin } from "@ngxs/devtools-plugin";
import { environment } from "src/environments/environment";
import { LoaderState } from "./shared/state/loader.state";
import { AuthState } from "./core/auth/state/auth.state";
import { AccountState } from "./core/account/state/account.state";
import { CartState } from "./core/cart/state/cart.state";
import { WalletState } from "./core/wallet/state/wallet.state";
import { DonateState } from "./shared/state/donate.state";
import { StreamerState } from "./features/streamer/state/streamer/streamer.state";
import { FreightState } from "./features/streamer/state/freight/freight.state";
import { WithdrawalState } from "./core/withdrawal/state/withdrawal.state";
import { ComissionState } from "./core/comission/state/comission.state";
import { ToastrModule } from "ngx-toastr";
import { CoreModule } from "./core/core.module";
import { LoadingBarRouterModule } from "@ngx-loading-bar/router";
import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { GetFeatureToggles } from "./core/feature-toggle/state/feature-toggle.action";
import { provideEnvironmentNgxMask } from "ngx-mask";
import { DonationState } from "./core/donations/state/donation.state";
import { StreamerFollowersState } from "./core/streamer-follow/state/followers/streamer-followers.state";
import { StreamerFollowingState } from "./core/streamer-follow/state/following/streamer-following.state";
import { PollingPort } from "./core/donations/ports/polling.port";
import { IntervalPollingAdapter } from "./core/donations/adapters/interval-polling.adapter";
import { DonationPollingState } from "./core/donations/state/donation-polling.state";
import { MusicthonPollingState } from "./core/musicthon/state/musicthon-polling.state";
import { CompanyState } from "./core/company/state/company.state";

export function loadFeatureToggles(store: Store, platformId: object) {
  return () => {
    if (!isPlatformBrowser(platformId)) return Promise.resolve();
    return store.dispatch(new GetFeatureToggles()).toPromise();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: "top"}),
    ),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideAnimationsAsync(), // 🎬 Habilita animações para ngx-toastr
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: "/assets/i18n/",
        suffix: ".json"}),
      fallbackLang: "pt",
      lang: "pt"}),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true},
    {
      provide: APP_INITIALIZER,
      useFactory: loadFeatureToggles,
      deps: [Store, PLATFORM_ID],
      multi: true},
    // Polling Port & Adapter (Ports & Adapters Architecture)
    {
      provide: PollingPort,
      useClass: IntervalPollingAdapter},
    provideEnvironmentNgxMask(),
    provideStore(
      [
        LoaderState,
        AuthState,
        AccountState,
        CartState,
        WalletState,
        DonateState,
        StreamerState,
        FreightState,
        WithdrawalState,
        ComissionState,
        DonationState,
        DonationPollingState,
        MusicthonPollingState,
        StreamerFollowersState,
        StreamerFollowingState,
        CompanyState],
      withNgxsReduxDevtoolsPlugin({ disabled: environment.stage !== 'local' }),
    ),
    importProvidersFrom(
      ToastrModule.forRoot({
        positionClass: "toast-top-center",
        preventDuplicates: true}),
      CoreModule,
      LoadingBarRouterModule,
    )]};
